import React from "react";
import styled from "@emotion/styled";
import { useNavigate } from "react-router-dom";
import { Button } from "antd";

const Consent = ({ onConsent }) => {
  const url =
    process.env.REACT_APP_FRONTEND_URL || "https://webapp.sonkthaiglairok.com";

  const indent = () => <>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</>;
  const navigate = useNavigate();
  return (
    <Container>
      <center>
        <Title>
          เอกสารแสดงความยินยอม (Consent Form) เพื่อใช้ในการเก็บรวบรวม ใช้
          และเปิดเผยข้อมูลส่วนบุคคลสำหรับการให้บริการเว็บแอปพลิเคชันและ/หรือ
          แบบทดสอบชุดความรู้ “เณรกล้า โภชนาดี” (“เว็บแอปฯ”)
        </Title>
      </center>
      <br />
      <Text>
        {indent()}โครงการ
        “การพัฒนาสื่อและหลักสูตรโภชนาการสามเณรสมวัยและการขับเคลื่อนสุขภาวะพระสงฆ์และสามเณรโดยภาคีร่วม”
        (“โครงการฯ”)
        ซึ่งได้รับการสนับสนุนจากสำนักงานกองทุนสนับสนุนการสร้างเสริมสุขภาพ (หรือ
        “สสส.”) ได้จัดทำสื่อโภชนาการในรูปแบบของเว็บแอปฯ
        <br />
        {indent()}เพื่อให้สอดคล้องกับกฎหมาย กฎระเบียบ และข้อบังคับที่เกี่ยวข้อง
        โครงการฯ จึงได้จัดทำเอกสารขอความยินยอมนี้จากท่านในการเก็บรวมรวม ใช้
        และเปิดเผย ข้อมูลส่วนบุคคลของท่านที่ให้ไว้แก่โครงการฯ ทั้งนี้
        ท่านมีสิทธิเลือกให้ความยินยอมหรือไม่ก็ได้ หากท่านไม่ยินยอม
        จะส่งผลให้ท่านไม่สามารถใช้งานฟังก์ชันบางประการที่จำเป็นต้องมีการลงทะเบียนหรือเข้าสู่ระบบก่อน
        <br />
        {indent()}ทั้งนี้ ก่อนการแสดงเจตนาให้หรือไม่ให้ความยินยอมนั้น
        ท่านได้อ่านและเข้าใจรายละเอียดจากเอกสารชี้แจงข้อมูล
        และ/หรือได้รับคำอธิบายจากโครงการฯ
        เป็นอย่างดีถึงวัตถุประสงค์และหลักการในการเก็บรวบรวม ใช้
        และเปิดเผยข้อมูลส่วนบุคคลของท่าน ตาม คำประกาศเกี่ยวกับความเป็นส่วนตัว
        (Privacy Notice)
        ซึ่งมีรายละเอียดเกี่ยวกับการคุ้มครองข้อมูลส่วนบุคคลของท่านแล้ว
        หากท่านและหรือผู้แทนโดยชอบธรรมยังไม่ได้อ่าน สามารถอ่านคำประกาศฯ ได้ที่{" "}
        <Link onClick={() => navigate("/privacyNotice")}>
          {url + "/privacyNotice"}
        </Link>
      </Text>
      <center>
        <ConfirmBtn onClick={onConsent}>ยินยอม</ConfirmBtn>
      </center>
    </Container>
  );
};

export default Consent;

const Container = styled.div`
  font-family: "Noto Sans Thai", "Noto Sans" !important;
  margin: auto;
  max-width: 1144px;
  min-height: calc(100vh - 154px);
  padding-left: 8px;
  padding-right: 8px;
`;

const Title = styled.div`
  font-style: normal;
  font-weight: 600;
  font-size: 23px;
  line-height: 28px;
  color: #058459;
  margin-top: 40px;
`;

const Text = styled.p`
  font-size: 19px;
`;

const BoldText = styled.span`
  font-weight: 700 !important;
`;

const Link = styled(BoldText)`
  color: #ff6a40 !important;
  font-family: "Noto Sans Thai", "Noto Sans" !important;
  cursor: pointer;
`;

const ConfirmBtn = styled(Button)`
  border-radius: 100px;
  padding: 14px 32px;
  width: 206px;
  height: 51px;
  color: #ffffff !important;
  background: #16af7b !important;
  font-weight: 700 !important;
  font-size: 19px !important;
  line-height: 23px;
  letter-spacing: -0.02em;
  margin-bottom: 24px;

  &:disabled {
    background: #d0d5dd;
    color: #64748b;
  }

  &.ant-btn:hover,
  &.ant-btn:focus {
    color: #16af7b;
    border-color: #16af7b;
  }
`;
